import { createFileRoute } from "@tanstack/react-router";
import { orpc } from "@/orpc/client";
import { PartnerDetailPage } from "@/pages/partners/detail/PartnerDetailPage";
import { PartnerDetailPageSkeleton } from "@/pages/partners/detail/PartnerDetailPageSkeleton";

export const Route = createFileRoute("/_app/partners/$partnerId/")({
	loader: async ({ context: { queryClient }, params }) => {
		queryClient.prefetchQuery(
			await orpc.partners.statistics.queryOptions({
				input: { id: params.partnerId },
			}),
		);

		return queryClient.ensureQueryData(
			orpc.partners.detail.queryOptions({
				input: { id: params.partnerId },
			}),
		);
	},
	head: ({ loaderData: partner }) => ({
		meta: [{ title: `${partner?.name ?? "Partner"} - Biteasy` }],
	}),
	pendingComponent: PartnerDetailPageSkeleton,
	component: PartnerDetailPage,
});
